import React, { useState, useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { FaArrowRight, FaStar } from "react-icons/fa";
import { IoIosArrowDropleft, IoIosArrowDropright } from "react-icons/io";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

const Recommended4 = ({ data }) => {
  const [showPrev, setShowPrev] = useState(true);
  const [showNext, setShowNext] = useState(true);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [themeColor, setThemeColor] = useState("#0000ff");
  const swiperRef_4 = useRef(null);
  const [commonSubCategoryAutoId, setCommonSubCategoryAutoId] = useState("");
  const [commonSubCategoryName, setCommonSubCategoryName] = useState("");
  const navigate = useNavigate();


  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const adminId = sessionStorage.getItem("admin_auto_id");
        const appTypeId = sessionStorage.getItem("app_type_id");
        const accessToken = sessionStorage.getItem("accessToken");
        const response = await axios.post(
          "https://gruzen.in/GrobizEcommerceAppBuilder/api/get_new_product_list",
          {
            admin_auto_id: adminId,
            app_type_id: appTypeId,
            component_auto_id: data._id,
            component_type: "Recommended",
            limit: 6,
            page_number: 1,
            customer_auto_id: accessToken || adminId,
          }
        );

        if (
          response.data.status === 1 &&
          Array.isArray(response.data.get_products_lists) &&
          response.data.get_products_lists.length > 0
        ) {
          setCommonSubCategoryAutoId(
            response.data.get_products_lists[0].sub_category_auto_id
          );
          setCommonSubCategoryName(
            "Shop Now"
          );
          const formattedProducts = response.data.get_products_lists.map(
            (product, index) => ({
              id: product.product_auto_id || index + 1,
              name: product.product_name || "No Name",
              image:
                product.product_images.length > 0
                  ? `https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${product.product_images[0].product_image}`
                  : "https://placehold.co/600x400",
              offerPrice: product.final_product_price || "0.00",
              actualPrice: product.product_price || "0.00",
              rating: product.average_rating || 0,
              discount: product.offer_percentage
                ? `${product.offer_percentage}% OFF`
                : null,
              user_auto_id: product.user_auto_id,
              size: product.size,
              get_price_lists: product.get_price_lists,
              offer_data: product.offer_data,
              moq: product.moq,

            })
          );

          setProducts(formattedProducts);
        } else {
          throw new Error("Failed to fetch products");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setThemeColor(parsedStyle.web_theme_colour);
    }
  }, []);

  if (loading || products.length === 0) {
    return null;
  }
  const handleViewAll = () => {
    navigate("/productlist", {
      state: {
        sub_cat_id: commonSubCategoryAutoId,
        subcategoryName: commonSubCategoryName
      },
    });
  };

  return (
    <>
      {/* 🖥️ Desktop View */}
      <div
        className={`hidden md:flex h-[600px] bg-cover bg-center items-center mx-2 rounded-lg mb-2 ${data.web_title_font}`}
        style={{
          backgroundImage: `url(https://grobizapp-n.s3.ap-south-1.amazonaws.com/slider/${data.background_image})`,
          overflow: "hidden",
        }}
      >
        <div className="flex flex-col items-center justify-center w-1/4 p-4">
          <h2
            className="mb-2 text-5xl font-bold text-center"
            style={{ color: data.web_title_color }}
          >
            {data.title}
          </h2>

          <button
            className="flex items-center justify-center p-3 text-black bg-transparent border-2 rounded-full"
            onClick={handleViewAll}
          >
            <FaArrowRight />
          </button>
        </div>

        {/* Slider */}
        <div className="relative w-full md:w-3/4 overflow-hidden">
          <Swiper
            ref={swiperRef_4}
            modules={[Navigation]}
            spaceBetween={20}
            slidesPerView={3.5}
            breakpoints={{
              0: { slidesPerView: 1.5, spaceBetween: 10 },
              768: { slidesPerView: 2.5, spaceBetween: 15 },
              1024: { slidesPerView: 3.5, spaceBetween: 20 },
            }}
            onSlideChange={(swiper) => {
              setShowPrev(!swiper.isBeginning);
              setShowNext(!swiper.isEnd);
            }}
            navigation={{
              prevEl: `.custom-prev-${data._id}`,
              nextEl: `.custom-next-${data._id}`,
            }}
          >
            {products.map((product) => (
              <SwiperSlide key={product.id}>
                <Link to={`/product-detail/${product.id}`}>
                  <div className="relative bg-white rounded-xl overflow-hidden">
                    <img
                      src={product.image}
                      alt={product.name}
                      className="w-full h-[450px] object-cover"
                    />
                    <div className="p-2 text-center">
                      <h3 className="text-sm font-semibold truncate">
                        {product.name}
                      </h3>
                      <span className="text-sm text-black">
                        ₹{product.offerPrice}
                      </span>
                    </div>
                  </div>
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>

      {/* 📱 Mobile View */}
      <div className={`md:hidden mb-6 ${data.web_title_font}`}>
        {/* Background with title and button on top */}
        <div
          className="relative h-[550px] mt-4 bg-cover bg-center rounded-lg overflow-hidden"
          style={{
            backgroundImage: `url(https://grobizapp-n.s3.ap-south-1.amazonaws.com/slider/${data.background_image})`,
          }}
        >
          {/* Overlay */}
          <div className="absolute inset-0 bg-black/40"></div>

          {/* Title and button */}
          <div className="absolute inset-0 flex flex-col items-center p-4 text-center z-10">
            <h2
              className="text-3xl font-bold mb-3 drop-shadow-lg text-white"
              style={{ color: data.web_title_color }}
            >
              {data.title}
            </h2>

            <button
              onClick={handleViewAll}
              className="flex items-center justify-center gap-2 text-white border-2 border-white rounded-full px-4 py-2 text-sm font-semibold hover:bg-white hover:text-black transition duration-300"
            >
              <span>Shop Now</span>
              <FaArrowRight />
            </button>
          </div>
          <div className="absolute bottom-6 left-0 w-full p-2 text-center block md:hidden z-20">
          <Swiper
            ref={swiperRef_4}
            modules={[Navigation]}
            spaceBetween={10}
            slidesPerView={1.5}
          >
            {products.map((product) => (
              <SwiperSlide key={product.id}>
                <Link to={`/product-detail/${product.id}`}>
                  <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                    <img
                      src={product.image}
                      alt={product.name}
                      className="w-full h-[320px] object-cover"
                    />
                    <div className="p-2 text-center">
                      <h3 className="text-sm font-semibold truncate">
                        {product.name}
                      </h3>
                      <span className="text-sm text-black">
                        ₹{product.offerPrice}
                      </span>
                    </div>
                  </div>
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        </div>
      </div>
    </>
  );
};

export default Recommended4;
